import moment from 'moment';

const state = () => ({});

const mutations = {};

const actions = {
  async LSC_getItem(_,id){
    let itemStr = localStorage.getItem(id);
    if(!itemStr){ return null; }
    let item = JSON.parse(itemStr);
    let now = moment(new Date());
    let expiry = moment(item.expiry);
    let expired = now.diff(expiry);
    if(expired>=0){ localStorage.removeItem(id); return null; }
    return item.data;
  },
  LSC_setItem(_,{data,ttl}){
    if(ttl===undefined){ ttl = 7; }
    let date = moment(new Date());
    let expiry = date.add(ttl,'days');
    let item = {data:data.value,expiry:expiry};
    localStorage.setItem(data.key,JSON.stringify(item));
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  